import { CFOPService, cfopsService } from '@modules/cfops/services/CFOP'
import { AxiosInstance } from 'axios'

import { ClientConfigProps } from '@shared/clients/types'

import { addressesService, AddressesService } from '@modules/addresses/services/Addresses'

import { aiBalancesService, AiBalancesService } from '@modules/ai/services/BalancesAI'
import { aiSessionsService, AiSessionsService } from '@modules/ai/services/Sessions'
import { aiTransactionsService, AiTransactionsService } from '@modules/ai/services/TransactionsAI'

import { passwordService, PasswordService } from '@modules/auth/services/Password'

import { ConsentsService, consentsService } from '@modules/consents/services/Consents'

import { dashboardCompaniesService, DashboardCompaniesService } from '@modules/dashboard/services/DashboardCompanies'

import { employeesPersonsService, EmployeesPersonsService } from '@modules/employees/services/Employees'
import { employeesAddressesService, EmployeesAddressesService } from '@modules/employees/services/EmployeesAddresses'
import { employeesArmiesService, EmployeesArmiesService } from '@modules/employees/services/EmployeesArmies'
import { employeesContractsService, EmployeesContractsService } from '@modules/employees/services/EmployeesContracts'
import { EmployeesDependentsService, employeesDependentsService } from '@modules/employees/services/EmployeesDependents'
import {
  employeesDriverLicensesService,
  EmployeesDriverLicensesService,
} from '@modules/employees/services/EmployeesDriversLicenses'
import { employeesFamiliesService, EmployeesFamiliesService } from '@modules/employees/services/EmployeesFamilies'
import {
  employeesIdentificationsService,
  EmployeesIdentificationsService,
} from '@modules/employees/services/EmployeesIdentifications'
import { employeesSpousesService, EmployeesSpousesService } from '@modules/employees/services/EmployeesSpouses'
import { employeesVoterCardsService, EmployeesVoterCardsService } from '@modules/employees/services/EmployeesVoterCards'
import { EmployeesWorkCardsService, employeesWorkCardsService } from '@modules/employees/services/EmployeesWorkCards'
import {
  employeesWorkingDaysService,
  EmployeesWorkingDaysService,
} from '@modules/employees/services/EmployeesWorkingDays'

import { productsService, ProductsService } from '@modules/products/services/Products'

import { returnTaxesService, ReturnTaxesService } from '@modules/return-taxes/services/ReturnTaxes'

import { usersService, UsersService } from '@modules/users/services/Users'

import { companiesApiConfig } from './config'

export class CompaniesAPI {
  private instance: AxiosInstance

  constructor(params: ClientConfigProps) {
    this.instance = companiesApiConfig(params).instance()
  }

  addresses(): AddressesService {
    return addressesService(this.instance)
  }

  aiBalances(): AiBalancesService {
    return aiBalancesService(this.instance)
  }

  aiSessions(): AiSessionsService {
    return aiSessionsService(this.instance)
  }

  aiTransactions(): AiTransactionsService {
    return aiTransactionsService(this.instance)
  }

  cfops(): CFOPService {
    return cfopsService(this.instance)
  }

  consents(): ConsentsService {
    return consentsService(this.instance)
  }

  dashboardCompanies(): DashboardCompaniesService {
    return dashboardCompaniesService(this.instance)
  }

  employeesAddresses(): EmployeesAddressesService {
    return employeesAddressesService(this.instance)
  }

  employeesArmies(): EmployeesArmiesService {
    return employeesArmiesService(this.instance)
  }

  employeesContracts(): EmployeesContractsService {
    return employeesContractsService(this.instance)
  }

  employeesDependents(): EmployeesDependentsService {
    return employeesDependentsService(this.instance)
  }

  employeesDriversLicenses(): EmployeesDriverLicensesService {
    return employeesDriverLicensesService(this.instance)
  }

  employeesFamilies(): EmployeesFamiliesService {
    return employeesFamiliesService(this.instance)
  }

  employeesIdentifications(): EmployeesIdentificationsService {
    return employeesIdentificationsService(this.instance)
  }

  employeesPersons(): EmployeesPersonsService {
    return employeesPersonsService(this.instance)
  }

  employeesSpouses(): EmployeesSpousesService {
    return employeesSpousesService(this.instance)
  }

  employeesVoterCards(): EmployeesVoterCardsService {
    return employeesVoterCardsService(this.instance)
  }

  employeesWorkCards(): EmployeesWorkCardsService {
    return employeesWorkCardsService(this.instance)
  }

  employeesWorkingDays(): EmployeesWorkingDaysService {
    return employeesWorkingDaysService(this.instance)
  }

  password(): PasswordService {
    return passwordService(this.instance)
  }

  products(): ProductsService {
    return productsService(this.instance)
  }

  returnTaxes(): ReturnTaxesService {
    return returnTaxesService(this.instance)
  }

  users(): UsersService {
    return usersService(this.instance)
  }
}

export const CompaniesFactoryAPI = (params: ClientConfigProps): CompaniesAPI => new CompaniesAPI(params)
